/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, imageTypes, animations, heights } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PARTNER LOGO STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	partner: {
		extend: imageTypes.logo,
		backgroundPosition: '100% 50%',
		// backgroundSize: '75% auto',
		width: pxToEm(110), // pxToEm(124),
		height: heights.header,
		// backgroundImage: `url(${url.image.client}logo-insticator-light.png)`, // will get dynamically created from partner component (image coming from settings file)
		'&:hover': {
			extend: animations.imageHover
		},
		'&.clickable-false': {
			pointerEvents: 'none',
			cursor: 'default'
		}
	}
};